const regxContent = /\{\{\s*replace\.(.*?)\s*(\|\s*\'(.*?)\'\s*)?\}\}/g;

const regxContentWithAttr = /\{\{\s*replace\.\{(.*?)\}\s*(\|\s*(.*?)\s*)?\-(.*?)\}\}/g;

const getRegxData = (content: string, index = 3, regx = regxContent) => {
  let flag = false;

  const txt = content.replace(regx, (...params) => {
    flag = true;
    if (index === 1) return params[1];
    return `{${params[index]}}`;
  });

  return {
    flag,
    txt
  };
};

const getRegxDataByTwoFacotor = (content: string, regx = regxContent) => {
  let selectType = '';
  let text = '';
  content.replace(regx, (...params) => {
    selectType = params[1];
    text = params[3];
  });

  return {
    selectType,
    text
  };
};

export { getRegxData, getRegxDataByTwoFacotor, regxContent, regxContentWithAttr };
